import { TranslationFormatter } from './TranslationFormatter';
import { InvoiceUpdatedNotification } from '../../commonTypes/NotificationTypes/clientService.types';

export class NotificationClientService {
    private formatter: TranslationFormatter;

    constructor(formatter: TranslationFormatter) {
        this.formatter = formatter;
    }

    public generateInvoiceUpdatedMessage(notification: InvoiceUpdatedNotification, userSub: string): string {
        const { invoiceId, invoiceName, initiatorUserSub, description } = notification.message;

        if (userSub === notification.initiatorUserSub) {
            return this.formatter.getTranslation('notificationMessages.invoiceUpdated.initiator', {
                invoiceId: invoiceId,
                invoiceName: invoiceName,
                description: description,
                initiatorUserSub: initiatorUserSub,
            });
        }

        return this.formatter.getTranslation('notificationMessages.invoiceUpdated.recipient', {
            invoiceId: invoiceId,
            invoiceName: invoiceName,
            description: description,
            initiatorUserSub: initiatorUserSub,
        });
    }
}
